/**
 * CRF Universal Utility Functions
 * 
 * This file contains common utility functions that are used across 
 * multiple JavaScript modules throughout the CRF application.
 * 
 * These functions are made globally available and should be loaded
 * before any modules that depend on them.
 */

/**
 * Extract post ID from the body class
 * 
 * WordPress automatically adds a class like 'postid-123' to the body element.
 * This function extracts and returns that post ID as an integer.
 * 
 * @returns {number|null} The post ID as an integer, or null if not found
 */

function getPostIdFromBodyClass() {
    const bodyClasses = jQuery('body').attr('class');
    
    if (!bodyClasses) {
        console.warn('getPostIdFromBodyClass: No body classes found');
        return null;
    }
    
    const postIdRegex = /postid-(\d+)/;
    const match = bodyClasses.match(postIdRegex);
    
    if (match && match[1]) {
        const postId = parseInt(match[1], 10);
        console.log('getPostIdFromBodyClass: Found post ID:', postId);
        return postId;
    }
    
    console.warn('getPostIdFromBodyClass: No post ID found in body classes:', bodyClasses);
    return null;
}

/**
 * Make utility functions globally available
 * 
 * These functions are attached to the window object so they can be 
 * accessed from any script that loads after this utility file.
 */
window.getPostIdFromBodyClass = getPostIdFromBodyClass;

// Log that utilities have been loaded
console.log('CRF Utilities loaded: getPostIdFromBodyClass available globally');